import { Intent } from 'src/shared/intent';

export const action = 'subscribe';
export type SubscribeIntent = Intent<[]>;
export const createSubscriptionIntent = (): SubscribeIntent => new Intent({ action, params: [] });
export const isSubscribeIntent = (intent: Intent): intent is SubscribeIntent => intent.action === action;
